import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";
import type { AssistantAvatarShape } from "../../assistantAvatarConfig";
import { CHARACTER_SHAPE_PATH } from "./characterShapes";

const { FACE } = ASSISTANT_AVATAR;

interface CharacterBodyProps {
	shape: AssistantAvatarShape;
	/** `url(#…)` of the body gradient the figure defines. */
	fill: string;
}

/** The filled shape plus its highlight and cheeks: everything on the body that isn't a feature. */
export const CharacterBody: FC<CharacterBodyProps> = ({ shape, fill }) => (
	<>
		<path d={CHARACTER_SHAPE_PATH[shape]} fill={fill} />
		<ellipse cx={40} cy={34} rx={12} ry={6.5} fill={FACE.SHINE} transform="rotate(-28 40 34)" />
		<ellipse cx={34} cy={74} rx={6.5} ry={3.8} fill={FACE.CHEEK_CHARACTER} />
		<ellipse cx={86} cy={74} rx={6.5} ry={3.8} fill={FACE.CHEEK_CHARACTER} />
	</>
);
